import { memo as Memo, useRef } from 'react'
import { useRouter } from 'next/router'

//* Components
import Image from 'components/common/Image'
import Text from 'components/common/Text'
import Container from 'components/common/Container'
import Animate from 'components/common/Animate'

//* Styles
import BannerTopStyle from './style'

const BannerTop = Memo(({ image, title }) => {
	//! Router
	const router = useRouter()

	//! Refs
	const blackLayerRef = useRef()
	const heroTitle = useRef()
	const heroTitleLine = useRef()

	return (
		<BannerTopStyle>
			<Container full section className={`banner-wrap`}>
				<Image objectFit={'cover'} className={'about-us-banner'} src={image?.url} alt={image?.alt} />
				<Animate params={{ layerTopToBottom: [blackLayerRef] }}>
					<div className='black-layer' ref={blackLayerRef} />
				</Animate>
				<div className='layer' />
				<div className='content-wrap'>
					<Container>
						<div className='title-wrap'>
							<Animate durationOpacity={0.8} startY={'100%'} params={{ opacityVertical: [heroTitle] }}>
								<Text
									tag={'h1'}
									className={`${
										router.pathname === '/career' || router.pathname === '/solution' ? 'addStyle' : ''
									} h2 uppercase primaryColor1 content-wrap-title font-montserratarm-regular`}
									text={title}
									ref={heroTitle}
								/>
							</Animate>
						</div>
						<Animate delay={0.2} params={{ lineHorizontal: [heroTitleLine] }}>
							<div className='line' ref={heroTitleLine} />
						</Animate>
					</Container>
				</div>
			</Container>
		</BannerTopStyle>
	)
})

export default BannerTop
